"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _recompose = require("recompose");

var _default = (0, _recompose.withProps)({
  isDiscourse: function isDiscourse() {
    return window && window._infl && window._infl.discourseHomepage;
  }
});

exports.default = _default;